export var formatNumericHumanDate = function (date) {
    return "".concat(date.getDate(), ".\u00A0").concat(date.getMonth() + 1, "\u00A0").concat(date.getFullYear());
};
